import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { Breadcrumb } from '@document-explorer/core';
import { DeUiIconComponent } from './ui-icon.component.js';

@Component({
  selector: 'de-breadcrumbs',
  standalone: true,
  imports: [DeUiIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <nav class="de-breadcrumbs" aria-label="Breadcrumb">
      @for (crumb of items(); track crumb.id; let index = $index, last = $last) {
        @if (index > 0) {
          <span class="de-crumb-separator" aria-hidden="true">
            <de-ui-icon name="chevronRight" />
          </span>
        }
        <button
          type="button"
          class="de-crumb"
          [attr.aria-current]="last ? 'page' : null"
          [disabled]="last"
          (click)="navigate.emit(crumb.id)"
        >
          {{ crumb.name }}
        </button>
      }
    </nav>
  `,
})
export class DeBreadcrumbsComponent {
  readonly items = input<Breadcrumb[]>([]);
  readonly navigate = output<string | null>();
}
